import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { EncryptionService } from "./encryption.service";
import { API_CONFIG } from "./api.config";

@Injectable()
export class EncryptionInterceptor implements HttpInterceptor {
  constructor(private encryptionService: EncryptionService) {}

  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Encrypt the request data using both RSA and AES encryption techniques
    const { url } = req;
    const isEncryptedApi = API_CONFIG.encryptedApis.some((api) =>
      url.includes(api)
    );
    if (isEncryptedApi) {
      // Create a new Observable to handle async/await operations
      return new Observable<HttpEvent<any>>((observer) => {
        // Await the encryption operation to get the actual encrypted data
        this.encryptionService
          .encryptAES(JSON.stringify(req.body))
          .then((encryptedData) => {
            
            // Modify the request with the encrypted data
            const encryptedReq = req.clone({
              body: {
                encryptedPayload: encryptedData.encryptedData,
                encryptedAesKey: encryptedData.encryptedAesKey,
                encryptedAesIV: encryptedData.encryptedAesIV,
              },
            });

            // Proceed with the modified request
            next.handle(encryptedReq).subscribe({
              next: (event) => {
                observer.next(event);
              },
              error: (error) => {
                observer.error(error);
              },
              complete: () => {
                observer.complete();
              },
            });
          })
          .catch((error) => {
            // Handle encryption errors appropriately
            console.error("Encryption failed:", error);
            observer.error(error);
          });
      });
    } else {
      // If it's not an encrypted API, continue with the original request
      return next.handle(req);
    }
  }
}
